import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Image, Button } from 'react-bootstrap';
import { MESSAGE } from "../../../utils/message";
import DataIntegrationOne from "../../../assests/images/api-data-integration/api-data-integration-1.webp";
import DataIntegrationTwo from "../../../assests/images/api-data-integration/api-data-integration-2.webp";

import {
    DataIntegrationSection,
    DataIntegrationMain,
    DataIntegrationWrap,
    DataIntegrationImage,
    DataIntegrationContent,
    DataIntegrationText,

    DataIntegrationButton,
} from "./solutions";

import { AdvocacyTitle, ElliottAdvocacyBanner } from "../../../components/common/commonSubPageBanner/commonSubPageBannerStyle";
import { useNavigate } from "react-router-dom";
import MetaComponent from "../../../components/common/metaComponent";

const GreatNonprofitsApi = () => {
    const navigate = useNavigate();
    return (
        <>
            <MetaComponent
                keywords=""
                description=""
                ogTitle="API &amp; Data Integration | GreatNonprofits"
                ogDescription=""
                ogUrl="https://www.about.greatnonprofits.org/greatnonprofits-api"
                ogImage="https://static.wixstatic.com/media/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg/v1/fit/w_2500,h_1330,al_c/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg"
            />
            <>
                <DataIntegrationSection>
                    {/* <SubPageBanner/> */}
                    <ElliottAdvocacyBanner>
                        <Container className="cont-w">
                            <AdvocacyTitle className='title-sub-page'> {MESSAGE.apiAndDataIntegration}</AdvocacyTitle>
                        </Container>
                    </ElliottAdvocacyBanner>

                </DataIntegrationSection>

                <DataIntegrationMain>
                    <Container className="cont-w">
                        <Row>
                            <Col sm="12">
                                <DataIntegrationWrap>
                                    <DataIntegrationImage>
                                        <Image src={DataIntegrationOne} alt="Data Integration One" />
                                    </DataIntegrationImage>

                                    <DataIntegrationImage>
                                        <Image src={DataIntegrationTwo} alt="Data Integration Two" />
                                    </DataIntegrationImage>

                                    <DataIntegrationContent>
                                        <DataIntegrationText>{MESSAGE.requestApiInformationText}</DataIntegrationText>
                                        <DataIntegrationButton onClick={() => navigate("/about")}>
                                            <Button className="btn-outline-success-blue">Request More Information</Button>
                                        </DataIntegrationButton>
                                    </DataIntegrationContent>

                                </DataIntegrationWrap>
                            </Col>
                        </Row>
                    </Container>
                </DataIntegrationMain>
            </>
        </>
    )
};
export default GreatNonprofitsApi;